






import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
@Component({
  name: 'lb-dialog',
})
export default class extends Vue {
  @Prop({
    default() {
      return {};
    },
  }) private mergeStyle!: object;
  @Prop({ default: '' }) private color!: string;
  @Prop() private opacity!: number;

  get styles() {
    return {backgroundColor: this.color, opacity: this.opacity, ...this.mergeStyle};
  }
}
